/**
 * resolveArRowFormulaSkip
 *
 * The single skip rule for ArTable per-row formulas, consumed by
 * computeArRowFormulas (engine core), useArTableFormulas (grid attach), and
 * the server formula trigger (stamp `skipped`). A row is skipped when it is
 * the aggregations row, carries `suppressFormulas` (writer-set values are
 * authoritative), or renders as a bundle header (`bundlesEnabled` on the
 * table AND `bundleRole === 'header'` AND a `bundleId`). Any divergence from
 * this rule silently re-enables formulas on rows that must never have them.
 */

import { AR_TABLE_AGGREGATIONS_ROW_ID } from '../System.Artifacts.types';
import type {
  ArRowData,
  ArRowFormulaSkipReason,
  ArRowId,
} from '../System.Artifacts.types';
import type { ArFormulaEngineConfig } from './createArFormulaEngineConfig';

function resolveArRowFormulaSkip(
  rowId: ArRowId,
  data: Partial<ArRowData> | undefined,
  config: ArFormulaEngineConfig,
): ArRowFormulaSkipReason | null {
  if (rowId === AR_TABLE_AGGREGATIONS_ROW_ID) return 'aggregationsRow';
  if (data?.suppressFormulas === true) return 'suppressFormulas';
  if (config.bundlesEnabled && data?.bundleRole === 'header' && Boolean(data?.bundleId)) {
    return 'bundleHeader';
  }
  return null;
}

export { resolveArRowFormulaSkip };
